import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

import { Storage } from '../helpers';

import Spinner from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function InstallAppCallBack() {
    const history = useHistory();
    const dispatch = useDispatch();
    const initProps = useSelector(state => state.init);
    const authProps = useSelector(state => state.auth);

    let location = new URLSearchParams(useLocation().search);

    useEffect(() => {
        dispatch({
            type: "INIT",
            payload: {
                shop: location.get('shop'),
                code: location.get('code')
            }
        });
    }, []);

    useEffect(() => {
        if (!isEmpty(initProps) && initProps.loading !== false) {
            dispatch({
                type: "LOGIN",
                payload: {
                    shop: location.get('shop')
                }
            });
        }
    }, [initProps]);

    useEffect(() => {
        if (!isEmpty(authProps) && authProps.token) {
            Storage.Add('token', authProps.token);

            if(!authProps?.initialized) {
                dispatch({
                    type: "GET_SHOPIFY_PRODUCTS",
                    payload: {}
                });

                setTimeout(() => {
                    history.push('/dashboard');
                }, 5000);
            } else {
                history.push('/dashboard');
            }
        }
    }, [authProps]);

    return (
        <div className="loaderContainer">
            <Spinner type="Rings" color="Black" height={150} width={150} visible={true} />
        </div>
    );
}

export default InstallAppCallBack;